import { render, staticRenderFns } from "./ParteSelect.vue?vue&type=template&id=6551691b&"
import script from "./ParteSelect.vue?vue&type=script&lang=js&"
export * from "./ParteSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports